<template>
  <div class="about">
    <title>关于焰川|企业建站|logo设计|网站维护|平面设计|网站推广</title>
    <meta name="keywords" content="深圳市微云腾科技有限公司,专业建站,模板定制建站,全定制建站,logo设计,平面设计">
    <!-- 关于我们头部 -->
    <div class="afirst">
      <img src="../assets/about/about.png" alt class="ayy" />
      <div class="abgc"></div>
      <div class="adbyy"></div>
      <div class="abig">
        <div class="contaniner">
          <div class="anav">
            <Navbar></Navbar>
          </div>
          <div class="aneirong">
            <div class="aleft">
              <p>
                ABOUT
                <br />US
                <span
                  style="color:#24C0EA;font-size:20px; width:80px;float:right;margin-top:28px;"
                >关于我们</span>
              </p>
            </div>
            <div class="aright">
              <span>
                <p>我们致力于为客户提供全方位网站开发服务与全球网络部署服务，为注重“企业形象”和“企业出海”的客户提供SDWAN跨境专线、SDWAN跨境组网专线、企业网站建设、百度首页自然排名、域名注册、全球租用、企业邮箱等服务。</p>
              </span>
              <p>专业的运维工程师、资深的WEB前端开发师、精湛的程序工程师、经验丰富的SEO优化师，这是我们的团队，也是一群怀揣梦想，充满激情的年轻人，我们不断学习，成长。积累的经验与案例将是我们最重要的资产。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 关于我们第二部分 -->
    <div class="asecond">
      <img src="../assets/about/yz.png" alt class="asyy" />
      <div class="asbgc"></div>
    </div>
    <!-- 关于我们第三部分 -->
    <div class="athree">
      <div class="atbgc"></div>
      <div class="atbig">
        <div class="contaniner">
          <ul class="atneirong">
            <li>
              <img src="../assets/about/ppxl.png" alt />
              <p style="color:#BBBBBB;font-size:18px">服务可靠</p>
              <br />
              <p style="color:#666666;font-size:14px">全球网络速达，降低延迟，维持0丢包</p>
            </li>
            <li>
              <img src="../assets/about/xjb.png" alt />
              <p style="color:#BBBBBB;font-size:18px">丰富的节点</p>
              <br />
              <p style="color:#666666;font-size:14px">覆盖全球200+主流城市</p>
            </li>
            <li>
              <img src="../assets/about/zzcx.png" alt />
              <p style="color:#BBBBBB;font-size:18px">1对1售后服务</p>
              <br />
              <p style="color:#666666;font-size:14px">7*24小时1对1服务，运维工程师在线</p>
            </li>
            <li>
              <img src="../assets/about/zyfw.png" alt />
              <p style="color:#BBBBBB;font-size:18px">品牌可信赖</p>
              <br />
              <p style="color:#666666;font-size:14px">新时代信用企业，服务内容贯穿每一个行业覆盖多个城市</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 关于我们第四部分 -->
    <div class="afour">
      <img src="../assets/about/fabout.jpg" alt class="afyy" />
      <div class="afbgc"></div>
    </div>
    <!-- 关于我们第五部分 -->
    <div class="afive">
      <div class="awbgc"></div>
      <div class="awbig">
        <div class="contaniner">
          <div class="aflimian">
          <div class="afleft">
            <p>
              合作声明<br>
              一、有参考有效率
              参考的提供，能很大的帮助我们判断客户需求的方向，方便报出预估价格的同时更能高速有效的给出成品。<br>
              二、。拒绝先做方案出来看看<br>
              好的方案和创意都需要时间去调研分析，团队开讨论会后才会碰撞出优质的方案。有些客户会认为先出个简单的方案花不了多少时间，这是个很大的误区，好方案就需要时间和思想的酝酿，否则是浪费双方的时间。<br>
              三、不以公关拿单子，没有行贿，没有回扣。<br>
              我们没有市场部，由创意与执行总监直接沟 通，我们不擅长也没有时间搞公关，更不能因此损害甲方利益，在微云腾没有行贿、没有回扣。我们将把有限的精力放在作品创作与服务客户上。<br>
              为了高效沟通，希望您在信任微云腾并认可以上三点合作流程后再联系巴顿和约见！这是我们的合作原则。微云腾注重高效，尊重时间，对作品追求完美。<br>
              看到这里也许您需要这个电话：+86 15992323574
            </p>
          </div>
          <div class="awdb"><router-link to="/share">或者您再看看我们的案例</router-link></div>
          <div class="afright">
            <p>
              焰川网络的职业素养<br>
              第一条 请允许我们的完美主义者，近乎苛刻的自我要求。<br>
              第二条 无论承受怎样的压力，绝不违背职业操守和良知。<br>
              第三条 向恩师投以尊敬与感谢，向同事投以欣赏和鼓励。<br>
              第四条 尽己所能照料和保护客户的利益。<br>
              第五条 严守客户机密。<br>
              第六条 维护品牌设计行业的声誉、尊重同行。<br>
              第七条 始终对客户讲真话，不忽悠，不扯淡。<br>
              第八条 真诚的坦露我们的优势。凡是偏离我们专业领域，我们必须谢绝。<br>
              第九条 每项工作我们须全力以赴，严格品控，而不是尽力而为。<br>
              第十条 有“知名度”更要竭尽追求 “美誉度”。树立良好的口碑。
            </p>
          </div>
        </div>
        </div>
      </div>
    </div>
    <!-- 关于我们底部 -->
    <div class="afoot">
        <Footer></Footer>
    </div>
  </div>
</template>
<style lang="scss" scope>
.about {
  .contaniner {
    width: 1200px;
    margin: 0 auto;
  }
  // 关于我们第一部分
  .afirst {
    width: 100%;
    height: 844px;
    position: relative;
    .ayy {
      width: 100%;
      height: 844px;
      filter: blur(1px);
    }
    .abgc {
      width: 100%;
      height: 844px;
      background-color: #000;
      opacity: 0.5;
      position: absolute;
      top: 0;
    }
    .adbyy {
      width: 100%;
      height: 350px;
      background-color: #000;
      opacity: 0.5;
      position: absolute;
      bottom: 0;
    }

    .abig {
      width: 100%;
      height: 844px;
      position: absolute;
      top: 0;
      .anav {
        width: 100%;
        height: 100px;
      }
      .aneirong {
        width: 100%;
        height: 210px;
        margin-top: 464px;
        .aleft {
          width: 165px;
          height: 130px;
          font-size: 48px;
          color: #bbbbbb;
          float: left;
        }
        .aright {
          width: 760px;
          height: 210px;
          float: right;
          span {
            display: block;
            width: 100%;
            height: 125px;
            color: #bbbbbb;
          }
          p {
            color: #bbbbbb;
          }
        }
      }
    }
  }
  // 关于我们第二部分
  .asecond {
    width: 100%;
    height: 600px;
    position: relative;
    .asyy {
      width: 100%;
      height: 600px;
      filter: blur(1px);
    }
    .asbgc {
      width: 100%;
      height: 600px;
      background-color: #000;
      opacity: 0.8;
      position: absolute;
      top: 0;
    }
  }
  // 关于我们第三部分
  .athree {
    width: 100%;
    height: 300px;
    position: relative;
    .atbgc {
      width: 100%;
      height: 300px;
      background-color: #111;
      position: absolute;
      top: 0;
    }
    .atbig {
      width: 100%;
      height: 250px;
      margin-top: 50px;
      position: absolute;
      top: 0;
      .atneirong {
        width: 100%;
        height: 250px;
        list-style: none;
        text-align: center;
        li {
          width: 250px;
          height: 250px;
          float: left;
          padding-left: 25px;
          padding-right: 25px;
          img {
            width: 50px;
            height: 50px;
            margin-bottom: 60px;
          }
        }
      }
    }
  }
  // 关于第四部分
  .afour {
    width: 100%;
    height: 600px;
    position: relative;
    .afyy {
      width: 100%;
      height: 600px;
      filter: blur(1px);
    }
    .afbgc {
      width: 100%;
      height: 600px;
      background-color: #000;
      opacity: 0.8;
      position: absolute;
      top: 0;
    }
  }
  // 关于我们第五部分
  .afive {
    width: 100%;
    height: 800px;
    position: relative;
    .awbgc {
      width: 100%;
      height: 800px;
      background-color: #111;
      position: absolute;
      top: 0;
    }
    .awbig {
      width: 100%;
      height: 800px;
      margin-top: 70px;
      position: absolute;
      top: 0;
      .aflimian{
      width: 100%;
      height: 800px;
      .afleft {
        width: 662px;
        height: 520px;
        font-size: 12px;
        line-height: 40px;
        margin-bottom: 30px;
        color: #BBBBBB;
        float: left;
      }
      .awdb{
        width: 220px;
        height: 29px;
        color: #ACACAC;
        a{
          color: #ACACAC;
        }
      }
      .afright {
        width: 406px;
        height: 358px;
        line-height: 25px;
        font-size: 12px;
        color: #BBBBBB;
        float: right;
      }
      }
    }
  }
}
</style>
<script>
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
export default {
  data() {
    return {};
  },
  methods: {},
  components: {
    Navbar,
    Footer
  }
};
</script>
